import { array } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import joinClasses from 'webapp/helpers/join-classes';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface Args {
	showExplanation: boolean;
	isDisabled: boolean;
	onRegressorAdd: () => void;
}

export default class ForecastsDataAddRegressorButtonComponent extends Component<Args> {
	@service('billing') declare billingService: Service.Billing;
	@service('account') declare accountService: Service.Account;

	get showLearnMore() {
		return !this.accountService.hideDataboxNotWhiteLabeledContentForNonAdmins;
	}

	@action
	handleClick() {
		this.args.onRegressorAdd();
	}
	<template>
		{{#if this.billingService.forecastModelingEnabled}}
			<div class="forecast-table-add-regressor">
				<div class="add-regressor-button-wrapper">
					<button
						type="button"
						class={{joinClasses
							(array "add-regressor-button" (if @isDisabled "disabled"))
						}}
						disabled={{@isDisabled}}
						{{on "click" this.handleClick}}
					>
						<div class="icon-container">
							<CommonUiIconComponent @name="Plus" @size="sm" />
						</div>
						<span class="button-text">Add impacting metric</span>
						<div class="beta-tag">Beta</div>
					</button>
				</div>
				{{#if @showExplanation}}
					<div class="add-regressor-explanation">
						Add metrics that affect the performance of your selected metric, set the
						expected change, and observe how your forecast will adjust.
						{{#if this.showLearnMore}}
							<a
								class="learn-more-link"
								href="https://help.databox.com/databox-forecasting-methodology"
								target="_blank"
							>
								Learn more
							</a>
						{{/if}}
					</div>
				{{/if}}
			</div>
		{{/if}}
	</template>
}
